import { render, staticRenderFns } from "./batchAddModal.vue?vue&type=template&id=4af60282&scoped=true"
import script from "./batchAddModal.vue?vue&type=script&lang=js"
export * from "./batchAddModal.vue?vue&type=script&lang=js"
import style0 from "./batchAddModal.vue?vue&type=style&index=0&id=4af60282&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4af60282",
  null
  
)

export default component.exports